var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.406982 3.84283L5.51351 8.94936L6.52005 9.9559L5.98323 9.17751L2.28586 3.84283H0.406982Z",
    fill: "#2B2B32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333252 3.49389H2.1249L1.45387 1.9975L0.333252 3.49389Z",
    fill: "#2B2B32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.45386 1.99749L2.12489 3.49389H3.92324L2.57448 0.501099L1.45386 1.99749Z",
    fill: "#005857"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82925 3.84283H2.28589L5.98325 9.17751L6.52008 9.9559L6.26509 9.31843L4.07753 3.84283H3.82925Z",
    fill: "#005857"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45337 3.84283L6.73486 9.54657L6.99657 10.2109L7.17774 9.7613L8.27152 7.03022L7.49313 3.84283H4.46679H4.45337Z",
    fill: "#005857"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55396 3.49388H6.12416H7.03676L5.49339 2.31958L4.55396 3.49388Z",
    fill: "#005857"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23853 3.33284L5.21824 2.10486L2.88306 0.333344L4.23853 3.33284Z",
    fill: "#005857"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88306 0.333344L5.21824 2.10486L6.36569 0.668858L6.63411 0.333344H5.68124H2.88306Z",
    fill: "#007A9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68784 0.823187L5.49341 2.31958L7.03677 3.49388H9.43906L7.70109 1.31975L6.99651 0.43399L6.68784 0.823187Z",
    fill: "#007A9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53309 3.84283H7.49316L8.27156 7.03022L8.27827 7.02351L9.53309 3.84283Z",
    fill: "#007A9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9222 3.84283L8.70093 6.89601L13.2773 4.03743L13.5927 3.84283H12.8747H10.1705H9.9222Z",
    fill: "#007A9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2774 4.03741L8.70102 6.896L7.49316 9.91562L7.50658 9.92233L13.358 4.07768L13.2774 4.03741Z",
    fill: "#005857"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7476 1.99749L13.6665 3.49389L11.4253 0.501099L10.7476 1.99749Z",
    fill: "#007A9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.439 1.83645L9.23789 0.333344H7.36572L9.7613 3.33284L10.439 1.83645Z",
    fill: "#007A9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7477 1.9975L10.0767 3.49389H13.6667L10.7477 1.9975Z",
    fill: "#007A9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23779 0.333344L10.4389 1.83645L11.11 0.333344H9.23779Z",
    fill: "#007A9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 9.87754,
    fill: "white",
    transform: "translate(0.333252 0.333344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/Diamond.dacaad98.svg";
export { ForwardRef as ReactComponent };